// src/ui/client/bg/star-shoot/index.jsx
'use client';
import React, { useEffect } from 'react';

import SocialIcons from './social';
import styles from './styles.module.css';

const generateUniquePositions = (count, minDistance = 0.1) => {
  const positions = [];
  while (positions.length < count) {
    const randomX = Math.random();
    const randomY = Math.random();
    const isFarEnough = positions.every(([x, y]) => Math.sqrt((x - randomX) ** 2 + (y - randomY) ** 2) > minDistance);
    if (isFarEnough) {
      positions.push([randomX, randomY]);
    }
  }
  return positions;
};

const ShootingStarsSection = () => {
  useEffect(() => {
    const stars = document.querySelectorAll(`.${styles.shootingStar}`);
    const uniquePositions = generateUniquePositions(stars.length);

    stars.forEach((star, i) => {
      const [randomX, randomY] = uniquePositions[i];
      const randomDelay = Math.random() * 5; // Délai entre 0 et 5 secondes
      const randomScale = Math.random() * 0.5 + 0.75; // Échelle entre 0.75 et 1.25
      const randomBrightness = Math.random() * 0.5 + 0.5; // Luminosité entre 0.5 et 1.0

      star.style.setProperty('--random-x', randomX);
      star.style.setProperty('--random-y', randomY);
      star.style.setProperty('--random-delay', randomDelay);
      star.style.setProperty('--random-scale', randomScale);
      star.style.setProperty('--random-brightness', randomBrightness);
    });
  }, []);

  return (
    <header className='header'>
      <div className='grow chrome header_title' role='heading' aria-label='Bannière Anton Yohan' aria-level='2'>
        Anton Yohan
      </div>
      {Array.from({ length: 20 }).map((_, i) => (
        <div key={i} className={styles.shootingStar} aria-hidden='true'></div>
      ))}
      <SocialIcons />
    </header>
  );
};

export default ShootingStarsSection;
